import styled from "styled-components"

export const RevolvingContainer = styled.div`
  grid-column: span 12;

  @media only screen and (max-width: 500px) {
    min-height: 200px;
  }
`

export const RevolvingMainTitle = styled.h1`
  ${({ theme: { typography } }) => typography.desktop.primaryCTA}
  text-transform: unset;
  text-align: center;
  
  @media only screen and (max-width: 760px) {
    ${({ theme: { typography } }) => typography.mobile.primaryCTA};
    text-transform: unset;
  }
`

export const RotatingText = styled.h2`
  ${({ theme: { typography } }) => typography.desktop.primaryCTA}
  text-transform: unset;
  color: #f51767;
  opacity: 0;
  margin-top: 5px;
  text-align: center;
  animation-fill-mode: forwards;
  animation-timing-function: ease;
  animation-duration: 1.5s;
  display: none;
  &.active {
    animation-name: rotate-last;
    display: block;
  }
  @keyframes textFaderIn {
    from {
      opacity: 0;
      transform: translateY(25%);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes rotate-last {
    0% {
      opacity: 0;
      transform: translate3d(0, 20px, 0);
    }
    50%,
    100% {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }
  @media only screen and (max-width: 760px) {
    margin-top: 0;
    ${({ theme: { typography } }) => typography.mobile.primaryCTA};
    text-transform: unset;
    color: #f51767;
  }
`
